import {
  AddressSystemType,
  NetworkIdType,
  PortfolioAsset,
  PortfolioElement,
} from '@sonarwatch/portfolio-core';

export type TagDetails = {
  text: string;
  icon?: string;
  color?: string;
};

export type AddressInfo = {
  addressSystem: AddressSystemType;
  address: string;
};

export const HealthMode = {
  factor: 'factor',
  ratio: 'ratio',
} as const;

export type HealthModeType = (typeof HealthMode)[keyof typeof HealthMode];

export const PortfolioTabs = {
  portfolio: 'portfolio',
  nfts: 'nfts',
  points: 'points',
} as const;

export type ProfileTabsType =
  (typeof PortfolioTabs)[keyof typeof PortfolioTabs];

export type AddressedPoints = Points & {
  address: string;
};

export type Points = {
  platformId: string;
  points: number;
  rank?: number;
};

export type PointsPlatform = {
  id: string;
  networkIds: NetworkIdType[];
  refferalLink?: string;
  guideLink?: string;
  refferalCode?: string;
  image: string;
  pointsName: string;
  participants?: number;
};

export enum AirdropViewMode {
  address,
  aidrop,
}

export type PortfolioElementO = PortfolioElement & {
  owner: string;
};

export type PortfolioAssetO = PortfolioAsset & {
  owner: string;
};
export type ValidatorInfo = {
  voter: string;
  name?: string;
  imageUri?: string;
  baseApy: number;
  jitoApy: number;
  stakingApy: number;
  totalApy: number;
  commission: number;
  stakeCommission: number;
  mevCommission: number;
};

export type CurrencyCodeKey =
  | 'USD'
  | 'BTC'
  | 'EUR'
  | 'JPY'
  | 'AED'
  | 'SOL'
  | 'SUI'
  | 'ETH'
  | 'GBP';

export type Currency = {
  name: CurrencyCodeKey;
  coinGeckoId: string;
  symbol: string;
  type: 'crypto' | 'fiat';
  symbolPosition?: 'before' | 'after';
  networkId?: NetworkIdType;
};

export type Invite = {
  invite_signer: string;
  invite_pda: string;
  sender: string;
  expiry: string;
  amount: string;
  creation_tx: string;
  deletion_tx?: string;
  receiver?: string;
  action?: 'claim' | 'clawback';
  creation_time: string;
  deletion_time?: string;
  code?: string;
  mode?: 'creation' | 'history';
};
